import {Navigate, Route, Routes} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {AuthLayout} from './AuthLayout'
import {Group} from './components/Group'
import { LoginByToken } from './components/LoginByToken'
import { ResetPassword } from './components/ResetPassword'

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>

      <Route path='login' element={<Login />} />
      <Route path='by_token' element={<LoginByToken />} />
      <Route path='registration' element={<Registration />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route path='reset' element={<ResetPassword />} />
      <Route index element={<Login />} />
      <Route path='*' element= {<Navigate to='/auth/login' />}/>
    </Route>
  </Routes>
)

const AuthPageGroup = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='group' element={<Group />} />

      <Route index element={<Group />} />
    </Route>
  </Routes>
)

export {AuthPage, AuthPageGroup}
